export const LICENSE_STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'draft', label: 'Draft' },
  { value: 'inactive', label: 'Inactive' },
];

export const LICENSE_STATUS_TABS = [
  { value: 'active', label: 'Active' },
  { value: 'draft', label: 'Draft' },
  { value: 'archived', label: 'Archived' },
];

export const LICENSE_STATUS_TAB_VALUES = LICENSE_STATUS_TABS.map((tab) => tab.value);

export const LICENSE_BILLING_INTERVAL_OPTIONS = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'half_yearly', label: 'Half Yearly' },
  { value: 'yearly', label: 'Yearly' },
];

export const LICENSE_DURATION_OPTIONS = [
  { value: 1, label: '1 Month', duration: 1, billingInterval: 'monthly' },
  { value: 3, label: '3 Months', duration: 3, billingInterval: 'monthly' },
  { value: 6, label: '6 Months', duration: 6, billingInterval: 'monthly' },
  { value: 12, label: '1 Year', duration: 1, billingInterval: 'yearly' },
  { value: 24, label: '2 Years', duration: 2, billingInterval: 'yearly' },
];

export const LICENSE_USER_OPTIONS = [
  { value: 1, label: '1 User' },
  { value: 3, label: '3 Users' },
  { value: 5, label: '5 Users' },
  { value: 10, label: '10 Users' },
  { value: 25, label: '25 Users' },
  { value: 50, label: '50 Users' },
  { value: 100, label: '100 Users' },
  { value: -1, label: 'Unlimited' },
];

export const LICENSE_AI_CREDITS_OPTIONS = [
  { value: 1000, label: '1,000 Credits' },
  { value: 5000, label: '5,000 Credits' },
  { value: 10000, label: '10,000 Credits' },
  { value: 25000, label: '25,000 Credits' },
  { value: 50000, label: '50,000 Credits' },
  { value: -1, label: 'Unlimited' },
];

/** MUI Select sentinel when the stored limit is not a preset option. */
export const LICENSE_LIMIT_CUSTOM_VALUE = '__custom__';

export const LICENSE_UNLIMITED_VALUE = -1;

export const CORE_PLAN_FEATURE_KEYS = {
  users: 'users',
  aiCredits: 'ai_credits',
};

export const LICENSE_STATUS_VALUES = LICENSE_STATUS_OPTIONS.map((o) => o.value);
export const LICENSE_DURATION_VALUES = LICENSE_DURATION_OPTIONS.map((o) => o.value);
export const LICENSE_USER_VALUES = LICENSE_USER_OPTIONS.map((o) => o.value);
export const LICENSE_AI_CREDITS_VALUES = LICENSE_AI_CREDITS_OPTIONS.map((o) => o.value);
export const LICENSE_BILLING_INTERVAL_VALUES = LICENSE_BILLING_INTERVAL_OPTIONS.map((o) => o.value);

export const DEFAULT_LICENSE_FORM = {
  name: '',
  alias: '',
  status: 'active',
  description: '',
  durationMonths: null,
  billingInterval: 'monthly',
  duration: 1,
  currency: 'INR',
  trialDays: 0,
  maxUsers: null,
  aiCredits: null,
  price: '',
  permissionProfileId: null,
};

export const FALLBACK_LICENSES = [
  {
    id: 'sample-gold',
    code: 'gold',
    name: 'Real Estate Gold License',
    alias: 'Gold',
    status: 'active',
    description: 'Premium plan with user seats and monthly AI credits.',
    durationMonths: 12,
    billingInterval: 'yearly',
    duration: 1,
    currency: 'INR',
    trialDays: 0,
    maxUsers: 25,
    aiCredits: 25000,
    price: 299000,
    permissionProfile: { id: 1, name: 'Standard Admin' },
    featureSummary: [
      { key: 'users', enabled: true, hard_limit: 25 },
      { key: 'ai_credits', enabled: true, hard_limit: 25000 },
    ],
    createdAt: '2026-07-01T10:00:00.000Z',
  },
  {
    id: 'sample-silver',
    code: 'silver',
    name: 'Real Estate Silver License',
    alias: 'Silver',
    status: 'active',
    description: 'Mid-tier plan with core user and AI credit allowance.',
    durationMonths: 6,
    billingInterval: 'monthly',
    duration: 6,
    currency: 'INR',
    trialDays: 0,
    maxUsers: 5,
    aiCredits: 5000,
    price: 59999,
    permissionProfile: { id: 2, name: 'Standard User' },
    featureSummary: [
      { key: 'users', enabled: true, hard_limit: 5 },
      { key: 'ai_credits', enabled: true, hard_limit: 5000 },
    ],
    createdAt: '2026-01-15T09:30:00.000Z',
  },
  {
    id: 'sample-bronze',
    code: 'bronze',
    name: 'Real Estate Bronze License',
    alias: 'Bronze',
    status: 'draft',
    description: 'Entry-level draft plan pending review before activation.',
    durationMonths: 3,
    billingInterval: 'monthly',
    duration: 3,
    currency: 'INR',
    trialDays: 7,
    maxUsers: 3,
    aiCredits: 1000,
    price: 19999,
    permissionProfile: { id: 2, name: 'Standard User' },
    featureSummary: [
      { key: 'users', enabled: true, hard_limit: 3 },
      { key: 'ai_credits', enabled: true, hard_limit: 1000 },
    ],
    createdAt: '2026-03-01T11:00:00.000Z',
  },
];
